import SEO from "@/components/SEO";
import { PageHero, Reveal, Section, Rich, UL, Callout, BtnPrimary } from "@/components/Bits";
import { CONTACT } from "@/content/policies";

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO
        title="About us"
        description="Middle Man is an on-demand local assistance platform operated by Tourist Junction Private Limited connecting customers with verified helpers across India."
        path="/about"
      />
      <PageHero
        kicker="About us"
        title="About Middle Man"
        subtitle="Connecting India with verified, nearby helpers for everyday work."
      />
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-20">
        <div className="space-y-14">
          <Reveal>
            <Section title="Company">
              <Rich text="**Legal name:** Tourist Junction Private Limited" />
              <Rich text="**Brand:** Middle Man" />
              <Rich text={`**Registered office:** ${CONTACT.address}`} />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="What we do">
              <Rich text="Middle Man is an on-demand local assistance platform that connects customers with verified Middle Men (independent service providers) for everyday work — including home assistance, shopping, grocery pickup, medicine pickup, parcel delivery, document submission, agriculture support, elderly assistance, cleaning, event help, government office work, and many other daily tasks." />
              <Rich text="Our goal is simple: make daily life easier by providing **trusted, verified, location-based service providers** across India." />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="How we operate">
              <UL items={[
                "Customers post work requests choosing a category and a nearby verified helper.",
                "Middle Men accept, travel, and complete jobs — with real-time tracking and OTP-secured start / finish.",
                "Rating & review system keeps quality high. Suspicious or fraudulent accounts are suspended.",
                "Personal data is protected as described in our Privacy Policy. Aadhaar / PAN are only used for verification and never resold.",
                "We operate as a discovery + coordination platform. Middle Men are independent service providers, not employees of Tourist Junction Private Limited.",
              ]} />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Our values">
              <UL items={[
                "Trust & verification — every provider is checked before activation.",
                "Fair pricing — transparent per-hour, per-visit, or negotiable rates displayed up-front.",
                "Local-first — nearby helpers are prioritised, respecting the fabric of Indian neighbourhoods.",
                "Privacy — minimal data collection, strong security, no unnecessary sharing.",
                "Safety first — direct cash-handling categories are excluded to prevent fraud.",
              ]} />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Safety notice — what NOT to ask a Middle Man to do">
              <Rich text="Middle Man is a coordinator, not a bank, courier, or valuables agent. For your own protection, please do NOT assign — and Middle Men will not accept — any work involving:" />
              <UL items={[
                "Cash: handling, carrying, depositing, withdrawing or transferring cash on your behalf.",
                "Gold, jewellery or other precious items.",
                "ATM/debit/credit cards, cheque books, UPI PINs, netbanking passwords or OTPs.",
                "Original property papers or sole-copy government IDs (unless the customer accompanies the Middle Man).",
              ]} />
              <Rich text="**Golden rule:** If a job involves cash, gold, cards, PINs or OTPs — don't assign it. Middle Man Platform will not be liable for losses arising from prohibited high-risk work." />
            </Section>
          </Reveal>

          <Reveal>
            <Section title="Always use Send Work">
              <Rich text="For every job, use the in-app **Send Work** flow. It creates a permanent record, enables OTP-secured start & completion, live tracking, and a one-tap complaint route. Off-platform bookings waive dispute-resolution support." />
            </Section>
          </Reveal>

          <Reveal>
            <Callout>
              <Rich text="Want to partner with us, list a service, or ask a business question? Write to **info.touristjunction@gmail.com**." />
            </Callout>
          </Reveal>

          <Reveal>
            <div className="flex flex-wrap gap-4 pt-2">
              <BtnPrimary to="/services" testid="about-explore-services-btn">Explore our services</BtnPrimary>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
